import { useEffect, useState } from "react";
import { Mail, MessageSquare, Send, Globe } from "lucide-react";
import api from "../lib/api";

export default function Contact() {
  const [cfg, setCfg] = useState({});
  useEffect(() => { api.get("/settings/public").then((r) => setCfg(r.data)); }, []);

  const wa = cfg.whatsapp_number?.replace(/[^\d+]/g, "");
  const im = cfg.imessage_number?.replace(/[^\d+]/g, "");
  const mail = cfg.support_email;

  return (
    <div data-testid="contact-page" className="max-w-3xl mx-auto px-6 py-16">
      <div className="font-mono text-xs uppercase tracking-widest text-[#00FF66]">// contact</div>
      <h1 className="font-heading font-bold text-4xl md:text-5xl mt-2">Talk to us.</h1>
      <p className="text-[#A1A1AA] mt-3">Real humans on the other end. We usually reply within minutes during business hours.</p>

      <div className="grid md:grid-cols-3 gap-4 mt-10">
        {wa && (
          <a href={`https://wa.me/${wa.replace("+", "")}`} target="_blank" rel="noopener noreferrer"
            className="surface surface-hover p-6 group block" data-testid="contact-page-whatsapp">
            <div className="w-11 h-11 rounded-full flex items-center justify-center" style={{ background: "#25D366" }}>
              <Send className="w-5 h-5 text-white" />
            </div>
            <div className="font-mono text-[10px] uppercase tracking-widest text-[#A1A1AA] mt-5">whatsapp</div>
            <div className="font-heading font-semibold mt-1 group-hover:text-[#25D366] transition-colors">Tap to chat</div>
            <div className="text-xs text-[#71717A] mt-1">Live agent · usually replies in minutes</div>
          </a>
        )}
        {im && (
          <a href={`sms:${im}`} className="surface surface-hover p-6 group block" data-testid="contact-page-imessage">
            <div className="w-11 h-11 rounded-full flex items-center justify-center" style={{ background: "#007AFF" }}>
              <MessageSquare className="w-5 h-5 text-white" />
            </div>
            <div className="font-mono text-[10px] uppercase tracking-widest text-[#A1A1AA] mt-5">imessage / sms</div>
            <div className="font-heading font-semibold mt-1 group-hover:text-[#007AFF] transition-colors">Tap to message</div>
            <div className="text-xs text-[#71717A] mt-1">iPhone & Apple devices supported</div>
          </a>
        )}
        {mail && (
          <a href={`mailto:${mail}`} className="surface surface-hover p-6 group block md:col-span-1" data-testid="contact-page-email">
            <div className="w-11 h-11 rounded-full flex items-center justify-center" style={{ background: "#00FF66" }}>
              <Mail className="w-5 h-5 text-black" />
            </div>
            <div className="font-mono text-[10px] uppercase tracking-widest text-[#A1A1AA] mt-5">email</div>
            <div className="font-heading font-semibold mt-1 group-hover:text-[#00FF66] transition-colors text-sm" style={{ wordBreak: "keep-all", overflowWrap: "normal", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} title={mail}>
              {mail}
            </div>
            <div className="text-xs text-[#71717A] mt-1">Replies within 24h</div>
          </a>
        )}
      </div>

      <div className="surface p-6 mt-10">
        <div className="flex items-center gap-2"><Globe className="w-4 h-4 text-[#00FF66]" /><h2 className="font-heading font-semibold text-lg">Worldwide</h2></div>
        <p className="text-[#A1A1AA] text-sm mt-2">We serve customers globally. Pricing is in USD; payments are processed via Stripe.</p>
      </div>
    </div>
  );
}
